var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M70.612 85.719H20.337c-4.744 0-8.522-3.97-8.287-8.711l3.34-55.803h58.502l4.995 55.599c.36 4.812-3.447 8.915-8.275 8.915z",
    stroke: "#24211E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M51.575 85.719H20.337c-4.744 0-8.522-3.97-8.287-8.711l3.34-55.803h41.956l3.3 54.98c.259 5.188-3.878 9.534-9.071 9.534z",
    stroke: "#24211E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M50.5 1.039v0c5.569 0 10.083 4.516 10.083 10.083v10.085H40.417V11.122c0-5.567 4.514-10.083 10.083-10.083z",
    stroke: "#24211E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M37.626 1.039c5.569 0 10.083 4.516 10.083 10.083v10.085H27.543V11.122c0-5.567 4.514-10.083 10.083-10.083z",
    stroke: "#24211E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.438 86H90.16",
    stroke: "#24211E"
  })));
}

export default SvgEmptyBag;